import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { ProgramDetails } from '../components/ProgramDetails';
import { Curriculum } from '../components/Curriculum';
import { SocialProof } from '../components/SocialProof';
import { Pricing } from '../components/Pricing';
import { FinalClose } from '../components/FinalClose';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#FFF8F0]" data-id="element-241">
      <Hero data-id="element-242" />
      <PainPoints data-id="element-243" />
      <ProgramDetails data-id="element-244" />
      <Curriculum data-id="element-245" />
      <SocialProof data-id="element-246" />
      <Pricing data-id="element-247" />
      <FinalClose data-id="element-248" />
    </main>;
}